module.exports = __webpack_public_path__ + "img/tree_layer_5_deco_1.c5ac3ca3.png";